import Vue from "vue";
import axios from "axios";
import ElementUI from "element-ui";
import { Loading, MessageBox } from "element-ui";
import md5 from "js-md5";
// 请求的地址前缀
const baseUrl =
  process.env.NODE_ENV === "development" ? "" : process.env.VUE_APP_API_DOMAIN;
const redirectDomianUrl =
  process.env.VUE_APP_UPLOAD_DOMAIN === "development"
    ? ""
    : process.env.VUE_APP_UPLOAD_DOMAIN;
// 暂定的验签的key 【后期可以定期更改】
const key = "uJnudhJUkmGKFSuT";
// 跨域带上cookies
axios.defaults.withCredentials = true;
const api = {
  myAxios(url, data, option) {
    option = option || {};
    let loadingInstance; // 加载效果
    if (!option.ignoreLoading && option.ignoreLoading !== undefined) {
      loadingInstance = Loading.service({
        lock: true,
        text: "正在加载...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
    }
    // 对请求参数的body进行排序 如果返回undefined则不需要进行排序
    var my_data = {
      Header: {
        AgentTicket: "",
        SourceType: 1,
        UserTicket: Vue.prototype.getCookie("CJML.APP.PC.UserTicket"), //从cookie里读取用户票据,
        SignCode: "789649779a49df79sad7fa9sd87",
        machineKey: "",
        timeStamp: Math.round(new Date().getTime() / 1000).toString(),
        version: 6.0,
      },
      Body: data,
    };
    // 重新组装SignCode 和 timeStamp
    let AssembleSignCode =
      my_data.Header.AgentTicket +
      JSON.stringify(data) +
      my_data.Header.machineKey +
      my_data.Header.UserTicket +
      my_data.Header.timeStamp +
      key;
    let AssembleSignCodes = AssembleSignCode.replace("undefined", "");
    //console.log(AssembleSignCodes);
    my_data.Header.SignCode = md5(AssembleSignCodes);
    return new Promise((resolve, reject) => {
      axios
        .post(baseUrl + url, my_data)
        .then((res) => {
          // ignoreLoading 请求的时候是否需要loading效果
          if (!option.ignoreLoading) {
            setTimeout(function() {
              if (loadingInstance) {
                loadingInstance.close();
              }
            }, 300);
          }
          if (!res.data.Header) {
            ElementUI.MessageBox({
              title: "提示",
              message: "请求异常",
            });
            reject(false);
            return false;
          }
          if (res.data.Header.ErrorCode !== 0) {
            if (
              res.data.Header.Message == 1 ||
              res.data.Header.Message == 2 ||
              res.data.Header.Message == 3
            ) {
              if (loadingInstance) loadingInstance.close();
              if (
                res.data.Header.Message == 1 ||
                res.data.Header.Message == 2
              ) {
                MessageBox({
                  message: "很抱歉，您今天的vin码查询次数已达上限！",
                  confirmButtonText: "申请增加查询次数",
                  callback: (r) => {
                    if (r == "confirm") {
                      InsertUserQueryVinCountSet(
                        res.data.Header.Message,
                        data.vinCode
                      )
                        .then((res) => {
                          console.log(res);
                          MessageBox({
                            title: "申请已提交",
                            message:
                              "为了方便您的使用，我们已临时增加了您的VIN码查询次数",
                            confirmButtonText: "知道了",
                            callback: () => {
                              location.reload();
                              // window.location.replace("http://www.runoob.com")
                            },
                          });
                        })
                        .catch((err) => {
                          console.log(err);
                        });
                    } else {
                      window.location.href = window.location.origin;
                    }
                  },
                });
              } else if (res.data.Header.Message == 3) {
                ElementUI.MessageBox({
                  title: "您今天的vin码查询次数已达上限！",
                  message: `您还可以联系客服，调升VIN码查询次数的上限`,
                  confirmButtonText: "知道了",
                  callback: () => {
                    window.location.href = window.location.origin;
                  },
                });
              }
            } else {
              ElementUI.Message({
                type: "error",
                message: res.data.Header.Message,
              });
              // 如果返回的状态码未401 直接跳到云商中心登录页面
              switch (res.data.Header.ErrorCode) {
                case 401:
                  setTimeout(function() {
                    window.open(redirectDomianUrl, "_self");
                  }, 5000);
                  break;
              }
              reject(false);
              return false;
            }
          }
          var resdata = JSON.parse(JSON.stringify(res));
          resolve(resdata.data.Body);
        })
        .catch((err) => {
          if (!option.ignoreLoading) {
            setTimeout(function() {
              if (loadingInstance) {
                loadingInstance.close();
              }
            }, 300);
          }
          ElementUI.MessageBox({
            title: "提示",
            message: err,
          });
          reject(false);
          return false;
        });
    });
  },
  updatedFile(file) {
    // 上传图片文件流
    var sendData = new FormData();
    sendData.append("file", file);
    return new Promise((resolve, reject) => {
      $.ajax({
        type: "post",
        url: baseUrl + "/api/Common/SaveImage",
        // data:{"id":val},     // data参数是可选的，有多种写法，也可以直接在url参数拼接参数上去，例如这样：url:"getUser?id="+val,
        data: sendData,
        //取消帮我们格式化数据，是什么就是什么
        processData: false,
        dataType: "json", // 返回浏览器的数据类型，指定是json格式，前端这里才可以解析json数据
        contentType: false,
        success: function(data) {
          resolve(data);
        },
        error: function(err) {
          reject(err);
        },
      });
    });
  },
};

function InsertUserQueryVinCountSet(val, vinCode) {
  return new Promise((resolve, reject) => {
    api
      .myAxios(
        "/api/UserCenter/InsertUserQueryVinCountSet",
        {
          Frequency: val,
          vinCode: vinCode,
        },
        {
          ignoreLoading: true,
        }
      )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export default api;

// 对入参的对象进行排序
function sortObj(obj) {
  var arr = [];
  for (var key in obj) {
    arr.push(key);
  }
  arr = arr.sort();
  var newMyData = {};
  for (var i in arr) {
    var itemKey = arr[i];
    newMyData[itemKey] = obj[itemKey];
  }
  return newMyData;
}
